/* eslint-disable */
import React, { useEffect } from "react";
import SharedLeadItem from "./components/SharedLeadItem";
import Checkbox from "@mui/material/Checkbox";
import warn from "../../../../constants/toast";
import enviroments from "../../../../enviroments";
import { ClipLoader } from "react-spinners";

import * as Styles from "./styles";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

interface Props {
  data: Array<LeadProps>;
  leadsTotal: number;
  refreshLeads: () => void;
}
interface LeadProps {
  nomeLead: string;
  serialNumber: number;
  idLeadCorretorSistemaOrigem?: string;
  idLeadSistemaOrigem?: string;
  telefone: string;
  email: string;
  leadsCompartilhadosCom: Array<SharedWithProps>;
}

interface SharedWithProps {
  nomeCorretorDestino: string;
  dataCriacao: string;
  idCorretorDestinoSistemaOrigem?: string;
  idLeadCompartilhado: string;
}

export const SharedLeadList: React.FC<Props> = ({
  data,
  leadsTotal,
  refreshLeads,
}) => {
  const [active, setActive] = React.useState(false);
  const [values, setValues] = React.useState<Array<string>>([]);
  const [showFooter, setShowFooter] = React.useState(false);
  const [loadExclude, setLoadExclude] = React.useState<boolean>(false);

  const handleSelectAll = () => {
    let array: string[] = [];
    let arrayobj: Array<SharedWithProps> = [];

    if (active === false) {
      data.forEach((item: LeadProps) =>
        item.leadsCompartilhadosCom.forEach((it: SharedWithProps) => {
          if (it.idLeadCompartilhado !== undefined) {
            array.push(it.idLeadCompartilhado);
            arrayobj.push(it);
          }
        })
      );

      handleAll(array, arrayobj);
      setActive(true);
    } else {
      data.forEach((item: LeadProps) =>
        item.leadsCompartilhadosCom.forEach((it: SharedWithProps) => {
          array.push(it.idLeadCompartilhado);
          arrayobj.push(it);
        })
      );

      handleAll([], arrayobj);
      setActive(false);
    }
  };

  const handleUncheck = (item: string) => {
    setValues((current) => current.filter((ite) => ite !== item));
  };

  const handleCheck = (item: any) => {
    if (values.includes(item)) {
      handleUncheck(item);
    } else {
      setValues([...values, item]);
    }
  };

  const handleAll = (item: string[], data: Array<SharedWithProps>) => {
    if (item.length > 0) {
      item.map((it: string) => setValues((current) => [...current, it]));
    } else {
      data.forEach((it: SharedWithProps) =>
        handleUncheck(it.idLeadCompartilhado)
      );
    }
  };

  useEffect(() => {
    if (values.length > 0) {
      setShowFooter(true);
    } else {
      setShowFooter(false);
    }
  }, [values]);

  async function handleDesqualificarLeads() {
    let params = {
      idsLeadsCompartilhados: values,
    };
    const toJson = localStorage.getItem("@token");
    const datas = toJson == null ? null : JSON.parse(toJson);
    setLoadExclude(true);

    try {
      const response = await fetch(
        `${enviroments.BASE_URL}leads/app-web/leads/excluir-compartilhamento-lead/v1?cc=${enviroments.CC_MOBILE}`,
        {
          method: "DELETE",
          body: JSON.stringify(params),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + datas.token,
            Host: "api.producthunt.com",
          },
        }
      );

      if (response.status === 200) {
        warn.wargingSuccess("Exclusão feita com sucesso");

        refreshLeads();
      }
      setLoadExclude(false);
      setShowFooter(false);
      setValues([]);
    } catch (err) {
      console.log(err);
      setLoadExclude(false);
      setShowFooter(false);
      setValues([]);
    }
  }

  return (
    <Styles.Container>
      <Styles.ContainerSelect>
        <Styles.RowSpace>
          <Styles.Row>
            <Checkbox checked={active} onClick={handleSelectAll} {...label} />
            <Styles.SelectText>
              Selecionar todos os {data?.length} leads
            </Styles.SelectText>
          </Styles.Row>

          <Styles.SelectText>
            Exibindo {data?.length} lead (s) de {leadsTotal}
          </Styles.SelectText>
        </Styles.RowSpace>
      </Styles.ContainerSelect>

      {data?.map((item: LeadProps) => (
        <>
          <SharedLeadItem
            allSelected={(item: string[], data: Array<SharedWithProps>) =>
              handleAll(item, data)
            }
            activeAll={active}
            data={item}
            onItemSelect={(item) => handleCheck(item)}
            checkedData={values}
          />
        </>
      ))}
      <Styles.FooterContainer show={showFooter}>
        <Styles.Button onClick={() => handleDesqualificarLeads()}>
          {loadExclude ? (
            <ClipLoader color="#fff" size={26} speedMultiplier={0.5} />
          ) : (
            "Remover compartilhamento"
          )}
        </Styles.Button>
      </Styles.FooterContainer>
    </Styles.Container>
  );
};
